var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategoriaSuculentas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 19.4C23.9438 19.4 24.3094 19.2473 24.579 18.9753C24.8486 18.7034 25 18.3346 25 17.95V15.05C25 14.6655 24.8486 14.2967 24.579 14.0247C24.3094 13.7528 23.9438 13.6 23.5625 13.6H3.4375C3.05625 13.6 2.69062 13.7528 2.42103 14.0247C2.15145 14.2967 2 14.6655 2 15.05V17.95C2 18.3346 2.15145 18.7034 2.42103 18.9753C2.69062 19.2473 3.05625 19.4 3.4375 19.4M23.5625 19.4H3.4375M23.5625 19.4L20.6875 31H6.3125L3.4375 19.4M13.4483 9.20655C13.4483 9.20655 9.02794 9.65025 6.71356 7.70581C4.39919 5.75991 4.92675 2.04357 4.92675 2.04357C4.92675 2.04357 9.34707 1.59987 11.6629 3.54432C13.9773 5.49021 13.4483 9.20655 13.4483 9.20655ZM13.5518 9.20655C13.5518 9.20655 17.9721 9.65025 20.2864 7.70581C22.6008 5.75991 22.0733 2.04357 22.0733 2.04357C22.0733 2.04357 17.6529 1.59987 15.3386 3.54432C13.0242 5.49021 13.5518 9.20655 13.5518 9.20655Z",
    stroke: "#69BF8E",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriaSuculentas);
export default __webpack_public_path__ + "static/media/categoriaSuculentas.107d3aff46ef30329e1a78ba0d273380.svg";
export { ForwardRef as ReactComponent };